export default __webpack_public_path__ + "static/assets/8e1b643a00b75a3288e6a1a1bf0c934d.jpg";